import { useState } from "react";
import { sessions } from "@githits/replay-shared";
import LanguageTabs from "./LanguageTabs";
import QueryDisplay from "./QueryDisplay";
import CodeBlock from "./CodeBlock";

/** Extract raw code and language from a markdown fenced code block. */
function parseCodeBlock(content: string): { code: string; language: string } {
  const match = content.match(/^```([^\s]+)?\n([\s\S]*?)```$/m);
  if (!match) return { code: content, language: "text" };
  return { code: match[2].trimEnd(), language: match[1] ?? "text" };
}

/** Get unique repository names from session references. */
function getSources(session: (typeof sessions)[string]): string[] {
  const seen = new Set<string>();
  return session.references
    .map((r) => r.repository)
    .filter((repo) => {
      if (seen.has(repo)) return false;
      seen.add(repo);
      return true;
    });
}

export default function HeroExamples() {
  const [activeLanguage, setActiveLanguage] = useState("python");
  const session = sessions[activeLanguage];
  const { code, language } = parseCodeBlock(session.example.content);
  const sources = getSources(session);

  return (
    <div
      className="ghw-flex ghw-flex-col"
      style={{
        padding: 16,
        gap: 16,
        background: "#21262d",
        borderRadius: 16,
        height: 500,
      }}
    >
      <LanguageTabs
        activeLanguage={activeLanguage}
        onSelect={setActiveLanguage}
      />
      <QueryDisplay query={session.query} />
      <CodeBlock code={code} language={language} sources={sources} />
    </div>
  );
}
